import {makeReactContext} from 'lib/makeReactContext';

import {StructuredTableKind} from '../StructuredTableConstants';

/**
 * Tells descendants that they are being rendered inside a structured table.
 * This is being used temporarily to always use the Inline Location Selector
 * in structured tables; in other tables, the component is dependent on a
 * feature flag.
 */

interface StructuredTableContextInterface {
  // structuredTableKind = null iff not in structured table
  structuredTableKind: StructuredTableKind | null;
  provenanceUuid: string | null;
}

const StructuredTableContext = makeReactContext<StructuredTableContextInterface>(
  () => ({
    structuredTableKind: null,
    provenanceUuid: null,
  }),
  'StructuredTableContext'
);

export default StructuredTableContext;
